import { render } from "./NextOrTodaysFD.vue?vue&type=template&id=0d06c52d&scoped=true"
import script from "./NextOrTodaysFD.vue?vue&type=script&lang=js"
export * from "./NextOrTodaysFD.vue?vue&type=script&lang=js"

import "./NextOrTodaysFD.vue?vue&type=style&index=0&id=0d06c52d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d06c52d"]])

export default __exports__